// lib
import React, { useRef, useMemo } from 'react'
import PropTypes from 'prop-types'

// components
import { default as ComponentContainer } from '@aytm/app/stats/page/question-views/components/Component'

import { Dropdown } from 'primereact/dropdown'

import ScriptItemText from '@aytm/app/stats/page/question-views/xq/ScriptItemText'
import ScriptItemSelect from '@aytm/app/stats/page/question-views/xq/ScriptItemSelect'

import Controls from '@aytm/app/stats/page/question-views/xq/Controls'
import Footer from '@aytm/app/stats/page/question-views/components/component/Footer'

// styles
import style from '@aytm/app/stats/page/question-views/xq/styles/Component.module.scss'

export const DataContext = React.createContext()

const Component = ({ model, data, basic, scripts, states, disabled, onSelect, onChange, onUpdateData }) => {
  const { script, args } = model

  const scriptsRef = useRef()

  const scriptsOptions = useMemo(
    () =>
      scripts.map(r =>
        r instanceof Object
          ? { key: r.value, text: r.text, description: r.description }
          : { key: r, text: r, description: r }
      ),
    [scripts]
  )

  const setTitle = description => {
    const element = scriptsRef.current.querySelectorAll('.p-dropdown-info')[0]
    if (element == undefined) {
      element.style.setProperty('--description', '')
      return
    }

    const txt = document.createElement('textarea')

    txt.innerHTML = description || (script && script.description) || ''

    element.style.setProperty('--description', `"${txt.value.replace(/\n/g, ' ')}"`)
  }

  const itemTemplate = option => (
    <span onMouseEnter={() => setTitle(option.description)} dangerouslySetInnerHTML={{ __html: option.text }}></span>
  )
  const valueTemplate = option =>
    option ? <span dangerouslySetInnerHTML={{ __html: option.text }}></span> : 'Please select...'

  const dataContextValue = useMemo(() => {
    return {
      model,
      data,
      disabled,
      onChange
    }
  }, [model, data, disabled, onChange])

  const renderScriptItem = item => {
    const value = args[item.id]

    switch (item.input) {
      case 'select': {
        return <ScriptItemSelect key={item.id} item={item} value={value} multiple={false} />
      }
      case 'multi-select': {
        return <ScriptItemSelect key={item.id} item={item} value={value} multiple={true} />
      }
      default: {
        return <ScriptItemText key={item.id} item={item} value={value} basic={(basic && basic[item.id]) || []} />
      }
    }
  }

  return (
    <ComponentContainer Controls={Controls} model={model} data={data} states={states} disabled={disabled}>
      <div className={style.component}>
        {0 < scripts.length ? (
          <>
            <div className={`${style.row} p-fluid p-col-12`}>
              <div ref={scriptsRef} className={`p-field p-col`} onMouseLeave={() => setTitle()}>
                <Dropdown
                  className="p-dropdown-info"
                  placeholder={'Please select...'}
                  value={(script && script.id) || null}
                  options={scriptsOptions}
                  optionValue="key"
                  optionLabel="text"
                  itemTemplate={itemTemplate}
                  valueTemplate={valueTemplate}
                  fixedDropdownDir="bottom"
                  disabled={disabled}
                  onChange={
                    disabled
                      ? null
                      : event => {
                          const description = scripts.find(v => event.value === v.value).description
                          setTitle(description)
                          onSelect(event.value)
                        }
                  }
                />
              </div>
            </div>
            <div className={style.list}>
              <DataContext.Provider value={dataContextValue}>
                {script != undefined && script.args.map(item => renderScriptItem(script.manifest[item.id]))}
              </DataContext.Provider>
            </div>
          </>
        ) : (
          <div className={`${style.row} p-col-12`}>Loading scripts...</div>
        )}
      </div>
      {!disabled && <Footer model={model} data={data} states={states} onUpdateData={onUpdateData} />}
    </ComponentContainer>
  )
}

Component.propTypes = {
  model: PropTypes.object,
  data: PropTypes.object,
  basic: PropTypes.object,
  scripts: PropTypes.array,
  states: PropTypes.object,
  disabled: PropTypes.bool,
  onSelect: PropTypes.func,
  onChange: PropTypes.func,
  onUpdateData: PropTypes.func
}

Component.displayName = 'Component'

export default Component
